<div class="modal-header">
  <h2 class="modal-title" id="modal-title">Thank You</h2>
  <button (click)="dismiss()" aria-label="Close" class="close" type="button" id="close">
    <span aria-hidden="true"></span>
  </button>
</div>
<div class="modal-body">
  <p>
    Your request for more information has been sent to our data specialist team. A representative will be in contact
    shortly.
  </p>
</div>
<div class="modal-footer">
  <button (click)="dismiss()" class="btn btn-primary" type="button">OK</button>
</div>
